import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { ShowPackageCandidateRequest } from '@schemas'
import { transferApi } from '@/api/show-transfer'
import { Button } from '@/components/ui/button'
export function CandidateSelect({
  type,
  showId,
  value,
  onChange,
}: {
  type: string
  showId?: string
  value?: string
  onChange: (id: string) => void
}) {
  const [search, setSearch] = useState('')
  const lookup = useMutation({
    mutationFn: () => transferApi.candidates({ type, showId, search }),
    gcTime: 0,
  })
  if (!ShowPackageCandidateRequest.shape.type.safeParse(type).success)
    return (
      <div>
        <label className="block">
          Destination record ID for {type}
          <input
            className="border rounded p-1 block"
            value={value ?? ''}
            maxLength={256}
            onChange={e => onChange(e.target.value.trim())}
          />
        </label>
        <span className="block text-sm">
          Enter the internal destination record ID, not an Exhibit ID. Preview validates the
          mapping.
        </span>
      </div>
    )
  return (
    <div className="flex min-w-0 flex-wrap gap-2 [&_label]:min-w-0 [&_select]:max-w-full [&_input]:max-w-full">
      <label>
        Search existing {type}
        <input
          className="border rounded p-1"
          value={search}
          onChange={e => {
            setSearch(e.target.value)
            lookup.reset()
          }}
        />
      </label>
      <Button
        type="button"
        variant="outline"
        disabled={lookup.isPending}
        onClick={() => lookup.mutate()}
      >
        Find records
      </Button>
      <label>
        Destination record
        <select
          className="border rounded p-1"
          value={value ?? ''}
          onChange={e => onChange(e.target.value)}
        >
          <option value="">Select a record</option>
          {value && !lookup.data?.candidates.some(c => c.id === value) && (
            <option value={value}>Selected destination record — {value}</option>
          )}
          {lookup.data?.candidates.map(c => (
            <option key={c.id} value={c.id}>
              {c.label} — {c.secondary} — {c.id}
            </option>
          ))}
        </select>
      </label>
      {lookup.data?.hasMore && <p>More records match. Refine your search.</p>}
      {lookup.data && !lookup.data.candidates.length && <p>No matching records in this context.</p>}
      {lookup.isError && <p role="alert">Unable to load records.</p>}
    </div>
  )
}
